module.exports = __webpack_public_path__ + "img/kachel-ALLERGIEN_CISTUSKAPSELN.7f0d0d85.png";